<au-expansion-panel
	[panelCanBeExpanded]="!!dataForTable?.length"
	[expanded]="isPanelOpen"
>
	<ng-container panel-title>
		<span class="section-name">{{ 'assets' | translate }}</span>
		@if (dataForTable?.length) {
			<span class="circle-container">{{ dataForTable?.length }} </span>
		}
	</ng-container>

	<ng-container panel-description>
		<open-dt-from-workspace
			entityName="asset"
			[entities]="dataForTable"
			class="open-dt-button"
		/>

		<button
			mat-mini-fab
			class="surface-fab"
			(click)="$event.stopPropagation()"
			[matMenuTriggerFor]="entityMenu"
		>
			<mat-icon svgIcon="add"></mat-icon>
		</button>
	</ng-container>

	<ng-container panel-content>
		<div class="table-wrapper nice-scroll colored-scroll-track">
			<au-table-layout
				[displayedColumns]="tableColumns"
				[data]="dataForTable"
				(cmmsDelete)="unlink.emit($event)"
				(tableRowClick)="viewEntity($event)"
				(selectColumn)="viewEntity($event)"
			>
			</au-table-layout>
		</div>
	</ng-container>
</au-expansion-panel>

<mat-menu
	#entityMenu="matMenu"
	class="au-select-actions"
	[xPosition]="'after'"
	[yPosition]="'below'"
>
	<button mat-menu-item (click)="openAttachAssets($event)">
		<mat-icon svgIcon="{{ iconEnum.asset }}"></mat-icon>
		<span>{{ 'add_existing_asset' | translate }}</span>
	</button>

	<button mat-menu-item (click)="addNew()">
		<mat-icon svgIcon="add"></mat-icon>
		<span>{{ 'add_asset' | translate }}</span>
	</button>
</mat-menu>
